import { State } from '@/stores/customers/state';
import { Actions } from '@/stores/customers/actions';
import { Getters } from '@/stores/customers/getters';
import { Mutations } from '@/stores/customers/mutations';
import { Module } from 'vuex';

export class CustomerStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
